import { app } from "@microsoft/teams-js";
import { initializeTeamsApp } from "./teamsBootstrap";

/**
 * Opens a link via the Teams SDK. If the SDK fails (e.g. outside Teams or an
 * initialization timeout) it falls back to `window.open`, so the link never
 * stops working.
 */
export async function openLink(url: string): Promise<void> {
  try {
    await initializeTeamsApp();
    await app.openLink(url);
  } catch (error) {
    console.warn("[Teams SDK] openLink failed, falling back to window.open", error);
    window.open(url, "_blank", "noopener,noreferrer");
  }
}
